import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import {
  baseServerUrl,
  ivrRequest,
  login_request,
  checkTokenValid,
  checkLoginFailure,
  TIMEOUT_MESSAGE,
  AXIOS_ERROR,
} from "../../constants/default_request";
import { toast } from "react-toastify";
import CloseTripWizard from "../../forms/IVR/CloseTrip/CloseForm1";
import OpenTripWizard from "../../forms/IVR/OpenTripHail/OpenTripForm1";
import NewDASTripWizard from "../../forms/IVR/DasOpenTrip/NewTripForm1";
import CloseDASTripWizard from "../../forms/IVR/DasCloseTrip/CloseTripForm1";
import CloseEFPTripWizard from "../../forms/IVR/EfpCloseTrip/CloseForm1";
import { saveIvrTrip } from "../../actions/ivrTripStorage";
import Token from "../../components/common/RefreshToken";
import { login, logout } from "../../actions/middleware_actions";
import Spinner from "../../components/common/Spinner";
import { BaseAPI } from "../../apis/BaseAPI";
import { useNavigate, useLocation } from "react-router-dom";

function ManageIvrTripPage({ userLogin, userLogout }) {
  const {
    permitNbr,
    tripType,
    type: actionType,
    trip_id,
    vtr_nbr,
    projectCode,
  } = useLocation().state;
  const { auth, error: apiErrors } = useSelector((state) => state);
  const request_data = ivrRequest(
    auth.client_id,
    auth.token,
    auth.user_app_status,
    permitNbr
  );
  const [errors, setErrors] = useState({});
  const formVersion = 1;
  const [openDialog, setOpenDialog] = useState(false);
  const didLoginFail = checkLoginFailure(apiErrors);
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();

  function handleSubmit(data) {
    const isTokenValid = checkTokenValid(auth);

    if (!isTokenValid) {
      setOpenDialog(true);
      return;
    }

    let end_point = `v_1_${tripType}_`;
    end_point = actionType.includes("open")
      ? end_point.concat("open")
      : end_point.concat("close");

    let request_url = `${baseServerUrl}/base_api/evtr/${end_point}`;
    if (auth.user_app_status === "TEST") {
      request_url = request_url.concat("/test");
    }

    const payload = {
      ...request_data,
      form_version: formVersion,
      form_name: `${tripType.toUpperCase()} ${
        actionType.includes("open") ? "OPEN" : "CLOSE"
      } TRIP HAIL`,
      vessel_permit_num: permitNbr,
      trip_id: trip_id,
      ...data,
    };
    console.log("Api call: ", request_url, payload);
    // changing spinner flag status
    setShowSpinner(true);
    BaseAPI.call(request_url, payload)
      .then((response) => {
        setShowSpinner(false);
        if (response.data.hasOwnProperty("errors")) {
          toast.error(`An error occurred: ${response.data.status}`, {
            autoClose: false,
          });
          console.log("API Error", response.data);
          setErrors({ onSubmitted: response.data.errors });
        } else {
          console.log("API Response", response.data);
          toast.success(`Submission status: ${response.data.status}`);
          navigate(`${process.env.PUBLIC_URL}/ivr`, {
            state: {
              trip_id: vtr_nbr,
              vesselNbr: permitNbr,
            },
          });
        }
      })
      .catch((error) => {
        let errorMessage = "";

        if (error.hasOwnProperty("message")) {
          errorMessage = error.message;
        }
        if (error.response) {
          // client received an error response (5xx, 4xx)
          console.log("Error response", error.response, error.message);
        } else if (error.request) {
          // client never received a response, or request never left
          console.log("Bad request", error.request, error.message);
          saveIvrTrip(auth.client_id, actionType, request_url, payload);
        }
        if (error.hasOwnProperty("name") && error.name === AXIOS_ERROR) {
          errorMessage = TIMEOUT_MESSAGE;
        } else {
          // anything else
          console.log("Other error", error, error.message);
        }
        toast.error(`An error occurred.  ${errorMessage}`, {
          autoClose: false,
        });
        setErrors({ onSubmitted: errorMessage });
      });
  }

  useEffect(() => {
    didLoginFail ? setOpenDialog(true) : setOpenDialog(false);
  }, [didLoginFail]);

  return (
    <>
      {openDialog && (
        <Token
          user={auth.username}
          loginRequest={login_request}
          loginUser={userLogin}
          logoutUser={userLogout}
          toggleDialog={setOpenDialog}
        />
      )}
      {
        {
          rsa_close: (
            <CloseTripWizard
              tripId={trip_id}
              vtr_nbr={vtr_nbr}
              permitNbr={permitNbr}
              tripType={tripType}
              projectCode={projectCode}
              returnedErrors={errors}
              onClose={handleSubmit}
            />
          ),
          open: (
            <OpenTripWizard
              tripId={trip_id}
              vtr_nbr={vtr_nbr}
              permitNbr={permitNbr}
              tripType={tripType}
              projectCode={projectCode}
              returnedErrors={errors}
              onOpen={handleSubmit}
            />
          ),
          das_open: (
            <NewDASTripWizard
              tripId={trip_id}
              vtr_nbr={vtr_nbr}
              permitNbr={permitNbr}
              returnedErrors={errors}
              handleSubmit={handleSubmit}
            />
          ),
          das_close: (
            <CloseDASTripWizard
              tripId={trip_id}
              vtr_nbr={vtr_nbr}
              permitNbr={permitNbr}
              returnedErrors={errors}
              handleSubmit={handleSubmit}
            />
          ),
          efp_close: (
            <CloseEFPTripWizard
              tripId={trip_id}
              vtr_nbr={vtr_nbr}
              permitNbr={permitNbr}
              returnedErrors={errors}
              handleSubmit={handleSubmit}
            />
          ),
        }[actionType]
      }
      {showSpinner && <Spinner />}
    </>
  );
}

const mapDispatchToProps = {
  userLogin: login,
  userLogout: logout,
};

export default connect(null, mapDispatchToProps)(ManageIvrTripPage);
